import { Component, OnInit, Input } from '@angular/core';
import { IHotelOffer } from '@core/models/hotel';
import { MbIconModule } from '@am/moebius';
import { NgClass } from '@angular/common';

@Component({
    selector: 'outstanding-promo',
    templateUrl: './outstanding-promo.component.html',
    styleUrls: ['./outstanding-promo.component.scss'],
    standalone: true,
    imports: [NgClass, MbIconModule],
})
export class OutstandingPromoComponent implements OnInit {
  @Input()
  offer: IHotelOffer;
  @Input()
  section: string;

  constructor() {}

  ngOnInit() {}
}
